export enum TotalWeightLossErrorCode {
    'gender' = 'gender',
}
